<template>
    <main>
        <div
            class="rounded overflow-hidden bg-white border border-primary-20 transition-all"
            :class="chosen ? 'my-16 pt-28 pl-28 pb-12 pr-12 shadow-lg bg-secondary-5' : 'mb-8 p-32 shadow-sm'"
        >
            <div class="flex items-center gap-24" :class="[{'mb-40': collapse && !collapseClasses}, collapseClasses]">
                <div class="flex-1 flex items-center gap-24">
                    <business-avatar
                        class="flex-none"
                        :class="logoClasses"
                        :icon="icon"
                        :link="href"
                    >
                        <slot></slot>
                    </business-avatar>

                    <div class="mr-auto">
                        <div class="flex gap-8">
                            <h3>
                                <span class="text-body first-letter:uppercase font-semibold">
                                    {{ $t('settings.integrations.' + translationKey + '.title') }}
                                </span>
                                <span v-if="extraInfo">({{ extraInfo }})</span>
                            </h3>
                            <tag
                                v-if="showTag"
                                :display="tagDisplay"
                                no-icon
                            >
                                {{ tagDescriptionVal }}
                            </tag>
                        </div>

                        <p class="text-body-sm">
                            {{ $t('settings.integrations.' + translationKey + '.description') }}
                        </p>
                    </div>
                </div>


                <div class="inline-flex gap-4 flex-wrap flex-col-reverse items-end xl:flex-row">
                    <simple-button
                        class="text-nowrap"
                        display="primary"
                        :icon="extraButtonArrowDirection ? 'keyboard-arrow-' + extraButtonArrowDirection : null"
                        v-if="showExtraButton"
                        @click="moreInfo"
                    >
                        {{ $t(extraButtonLabel) }}
                    </simple-button>

                    <simple-button
                        class="text-nowrap"
                        :disabled="disabled"
                        display="primary"
                        :icon="buttonArrowDirection ? 'keyboard-arrow-' + buttonArrowDirection : null"
                        :loading="working"
                        look="primary"
                        @click="handleClick"
                    >
                        {{ $t(active ? disconnectLabel : connectLabel) }}
                    </simple-button>
                </div>
            </div>

            <div
                v-if="collapse"
                class="custom-collapse"
                :class="collapse ? 'expanded' : ''"
            >
                <slot name="collapse"></slot>
            </div>
        </div>
    </main>
</template>

<script>
import SimpleButton from '../ui/SimpleButton.vue';
import SvgIcon from '../ui/SvgIcon';
import Tag from "../ui/Tag.vue";
import BusinessAvatar from "../ui/BusinessAvatar.vue";

export default {
    components: {
        BusinessAvatar,
        Tag,
        SvgIcon,
        'simple-button': SimpleButton,
    },
    props: {
        showTag: {
            type: Boolean,
            default: false,
        },
        tagDescription: {
            type: String
        },
        tagDisplay: String,
        collapse: {
            type: Boolean,
            default: false,
        },
        collapseClasses: {
            type: [String, null],
            default: null,
        },
        translationKey: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
        extraInfo: String,
        working: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        },
        href: String,
        logoClasses: String,
        connectLabel: {
            type: String,
            default: 'settings.integrations.link_button',
        },
        disconnectLabel: {
            type: String,
            default: 'settings.integrations.forget_button',
        },
        chosen: {
            type: Boolean,
            default: false,
        },
        showExtraButton: Boolean,
        extraButtonLabel: {
            type: String,
            default: 'settings.integrations.extra_button',
        },
        buttonArrowDirection: {
            type: String,
            default: '',
            validator: value => ['up', 'down', 'right', 'left'].includes(value) || value === '',
        },
        extraButtonArrowDirection: {
            type: String,
            default: 'down',
            validator: value => ['up', 'down', 'right', 'left'].includes(value),
        },
        icon: String,
        altDescription: {
            type: String,
            default: null,
        }
    },
    computed: {
        description() {
            return this.altDescription ? this.altDescription : this.$t('settings.integrations.' + this.translationKey + '.description');
        },
        tagDescriptionVal() {
            return this.tagDescription ?? this.$t('general.active');
        }
    },
    methods: {
        handleClick() {
            this.$emit(this.active ? 'disconnect' : 'connect');
        },
        moreInfo() {
            this.$emit('extraButton');
        },
    },
};
</script>

<style scoped>
.transition-all {
    transition: all .5s ease-in-out;
}
.custom-collapse {
    margin-top: -100%;
    transition: all 5s ease-in-out;
}
.custom-collapse.expanded {
    margin-top: 0;
}
</style>
